module.exports = __webpack_public_path__ + "img/initiative_ac3.f17faf01.jpg";